"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printManager = void 0;
const pdfMakeStyles_1 = require("./pdfMakeStyles");
const print_util_1 = require("./print-util");
const sheets_1 = require("./sheets");
class PrintManager extends print_util_1.PrintUtil {
    constructor() {
        super(...arguments);
        this.generateBillingSheet = (printMeta, lastPage) => new sheets_1.BillingSheet(printMeta, lastPage).make();
        this.generateClaimLabel = (printMeta, lastPage) => new sheets_1.ClaimLabel(printMeta, lastPage).make();
        this.generateInvoice = (printMeta, lastPage) => new sheets_1.Invoice(printMeta, lastPage).make(); // D-002 this is used for print invoice
        this.generateReceipt = (printMeta, lastPage) => new sheets_1.Receipt(printMeta, lastPage).make(); // D-002.60 this is used for print Receipt
        this.generateMonograph = (printMeta, lastPage) => new sheets_1.Monograph(printMeta, lastPage).make();
        this.generatePharmacy = (printMeta, lastPage) => new sheets_1.Pharmacy(printMeta, lastPage).make();
        this.generateWaiver = (printMeta, lastPage) => new sheets_1.Waiver(printMeta, lastPage).make();
        this.generateWarning = (printMeta, lastPage) => new sheets_1.Warning(printMeta, lastPage).make();
        this.initiatePrint = (printMetas) => {
            const contents = this.generateContents(printMetas);
            return {
                content: [...contents],
                defaultStyle: {
                    font: "Roboto"
                },
                styles: pdfMakeStyles_1.pdfMakeStyles
            };
        };
        this.generateContents = (printMetas) => {
            return printMetas.map((printMeta, indexMain, arrMain) => {
                const { printOptions } = printMeta;
                const optionEntries = Object.entries(printOptions);
                return optionEntries
                    .filter(([key, value]) => value)
                    .map(([key, value], index, arr) => {
                    const lastPage = index === arr.length - 1 && indexMain === arrMain.length - 1;
                    let content;
                    switch (key) {
                        case "billingSheet":
                            content = this.generateBillingSheet(printMeta, lastPage);
                            break;
                        case "claimLabel":
                            content = this.generateClaimLabel(printMeta, lastPage);
                            break;
                        case "invoice":
                            content = this.generateInvoice(printMeta, lastPage); // D-002 this is used for print invoice
                            break;
                        case "receipt":
                            content = this.generateReceipt(printMeta, lastPage); // D-002.60 this is used for print receipt
                            break;
                        case "monograph":
                            content = this.generateMonograph(printMeta, lastPage);
                            break;
                        case "patientWaiver":
                            content = this.generateWaiver(printMeta, lastPage);
                            break;
                        case "warningLabel":
                            content = this.generateWarning(printMeta, lastPage);
                            break;
                        case "pharmacyLabel":
                            content = this.generatePharmacy(printMeta, lastPage);
                            break;
                        default:
                            content = [];
                            break;
                    }
                    return content;
                });
            });
        };
    }
}
exports.printManager = new PrintManager();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/print-labels/print-manager/print-manager.ts
// module id = 2716
// module chunks = 0 1